// extracted by mini-css-extract-plugin
module.exports = {"root":"ProfileSidebarItem_root__j39ld"};